import { PureComponent } from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { serializeError } from 'serialize-error';
import { logError } from './actions';

const withLogError = (BaseComponent) => {
  function mapDispatchToProps(dispatch) {
    return {
      onLogError: (args) => dispatch(logError(args)),
    };
  }
  class LogError extends PureComponent {
    static propTypes = {
      onLogError: PropTypes.func.isRequired,
    };

    handleLogError = (error, origin = 'COMPONENT EVENT') => {
      const errorFunction = console.error ?? console.log;
      errorFunction(error);
      this.props.onLogError({
        error: get(serializeError(error), 'stack', error),
        origin,
      });
    };

    handleCatchError = (fn, origin = 'COMPONENT EVENT') => {
      try {
        const result = fn();
        return result;
      } catch (error) {
        const errorFunction = console.error ?? console.log;
        errorFunction(error);
        this.props.onLogError({
          error: get(serializeError(error), 'stack', error),
          origin,
        });
        return null;
      }
    };

    render() {
      return (
        <BaseComponent
          {...this.props}
          logError={this.handleLogError}
          catchError={this.handleCatchError}
        />
      );
    }
  }
  return connect(() => ({}), mapDispatchToProps)(LogError);
};

export default withLogError;
